/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}div.outerwrap[_ngcontent-%COMP%]{height:100%}.scroll[_ngcontent-%COMP%]{overflow-y:auto}.mat-cell.mat-checkbox[_ngcontent-%COMP%]{overflow:visible}.mat-column-Name[_ngcontent-%COMP%], .mat-column-ReferenceNum[_ngcontent-%COMP%]{-webkit-box-flex:2;-ms-flex:2;flex:2}.actionbar[_ngcontent-%COMP%]{margin-top:15px}.bottompad[_ngcontent-%COMP%]{margin-bottom:15px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/fullschedule/fullschedule.dialogcomponent.css.shim.ngstyle.js.pre-build-optimizer.js